import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["part"]
const _hoisted_2 = {
  key: 1,
  class: "table-responsive pis-scroll"
}
const _hoisted_3 = { class: "table" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("col", null, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  style: {"overflow":"hidden","text-align":"right"}
}
const _hoisted_10 = {
  type: "button",
  class: "btn btn-link text-dark"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 2,
  class: "my-3 text muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InjectStyles = _resolveComponent("InjectStyles")!
  const _component_VRuntimeTemplate = _resolveComponent("VRuntimeTemplate")!
  const _component_Clickable = _resolveComponent("Clickable")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_CatalogSearchTableActions = _resolveComponent("CatalogSearchTableActions")!
  const _component_DropdownPopper = _resolveComponent("DropdownPopper")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["pis-component", _ctx.componentName]),
    part: _ctx.componentName,
    style: {"z-index":"1"}
  }, [
    (_ctx.isReady && _ctx.componentOptions.visible)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.isWebComponent)
            ? (_openBlock(), _createBlock(_component_InjectStyles, {
                key: 0,
                items: _ctx.store?.options.styles
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          (_ctx.catalogItems && _ctx.catalogItems.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("table", _hoisted_3, [
                  _createElementVNode("colgroup", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, index) => {
                      return (_openBlock(), _createElementBlock("col", {
                        key: index,
                        style: _normalizeStyle({ width: col.width })
                      }, null, 4))
                    }), 128)),
                    _hoisted_4
                  ]),
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, index) => {
                        return (_openBlock(), _createElementBlock("th", { key: index }, [
                          (col.headerTemplate)
                            ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                                key: 0,
                                template: col.headerTemplate,
                                "template-props": { t: _ctx.t, col }
                              }, null, 8, ["template", "template-props"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(col.caption), 1)
                              ], 64))
                        ]))
                      }), 128)),
                      (_ctx.actionsEnabled)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_5))
                        : _createCommentVNode("", true),
                      _hoisted_6
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogItems, (catalog, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: catalog.catalogId?.code
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, index) => {
                          return (_openBlock(), _createElementBlock("td", { key: index }, [
                            (col.cellTemplate)
                              ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                                  key: 0,
                                  template: col.cellTemplate,
                                  "template-props": {
                    instance: _ctx.instance,
                    col,
                    item: catalog,
                    emit: _ctx.emit,
                    details: _ctx.details,
                    attrValue: _ctx.attrValue,
                    attrValues: _ctx.attrValues,
                    t: _ctx.t,
                  }
                                }, null, 8, ["template", "template-props"]))
                              : (col.dataField === 'code')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                    _createVNode(_component_Tooltip, {
                                      trigger: "hover",
                                      text: _ctx.t('ItemsInCatalog', false, [`${catalog.productsTotalCount}`])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Clickable, {
                                          onClick: ($event: any) => (_ctx.details(catalog.catalogId!))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(catalog.catalogId?.code), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1032, ["text"])
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(catalog[col.dataField!]), 1))
                          ]))
                        }), 128)),
                        (_ctx.actionsEnabled)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                              _createVNode(_component_DropdownPopper, {
                                class: "d-inline-block",
                                placement: 'bottom-start',
                                interactive: true,
                                top: index >= _ctx.catalogItems.length - 2
                              }, {
                                trigger: _withCtx(() => [
                                  _createElementVNode("button", _hoisted_10, [
                                    _createVNode(_component_Icon, { glyph: "menu" })
                                  ])
                                ]),
                                dropdown: _withCtx(({ close }) => [
                                  _createVNode(_component_CatalogSearchTableActions, {
                                    t: _ctx.t,
                                    "instance-id": _ctx.instance?.id,
                                    catalog: catalog,
                                    close: close
                                  }, null, 8, ["t", "instance-id", "catalog", "close"])
                                ]),
                                _: 2
                              }, 1032, ["top"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", null, [
                          (catalog.default)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                _createVNode(_component_Icon, { glyph: "star" })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.t('NoResults')), 1))
        ], 64))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}